export default __webpack_public_path__ + "static/media/mosaic-logo-icon-white.a8a163f6.svg";